import styled, { css } from 'styled-components'

// type WrapperProps = {
//   cellRelative?: boolean
//   isRowClickable?: boolean
// }

export const Wrapper = styled.div`
  width: 100%;
  display: flex;

  .dx-datagrid {
    flex: 1;
    min-height: 0;
    min-width: 0;
    width: 100% !important;
    font-size: 16px;
    font-family: ${({ theme }) => theme.ds.typography.fontFamily};
    border-radius: 8px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
      0 2px 1px -1px rgba(0, 0, 0, 0.2);
  }

  .dx-datagrid .dx-header-row {
    font-family: ${({ theme }) => theme.ds.typography.fontFamily} !important;
  }

  .dx-datagrid .dx-row {
    font-family: 'Roboto', sans-serif !important;
  }

  .dx-datagrid-focus-overlay {
    border-radius: 8px;
    ${({ theme }) => css`
      border: 2px solid ${theme.ds.colors.primary600};
    `}
  }

  .dx-datagrid-headers {
    ${({ theme }) => css`
      font-weight: ${theme.ds.typography.weight.bold};
      font-size: ${theme.ds.typography.size.xxsmall};
      border-radius: 8px 8px 0 0;
      color: ${theme.ds.colors.primary700};
      border-color: ${theme.ds.colors.primary50};
      background-color: ${theme.ds.colors.primary50};

      /* TODO: ... */
      /* td {
        position: relative;

        .dx-datagrid-text-content {
          display: flex;
          align-items: center;
          justify-content: center;
          width: fit-content;
          border: 1px solid red;
        }

        .dx-column-indicators {
          position: absolute;
          margin-left: 8px;
          top: 50%;
          transform: translateY(-50%);
          border: 1px solid black;
          padding: 0;
        }

        .dx-header-filter {
          margin-left: 4px;
          border: 1px solid red;
          margin: 0;
        }
      } */

      .dx-row {
        td {
          border-bottom: none;
          border-color: ${theme.ds.colors.primary50};
          padding: 16px 8px;
        }
      }

      .dx-header-filter {
        cursor: pointer;
        color: ${({ theme }) => theme.ds.colors.primary700};
        transition: color ease 0.1s;
      }

      .dx-header-filter-empty {
        color: ${({ theme }) => theme.ds.colors.primary100};

        &:hover {
          color: ${({ theme }) => theme.ds.colors.primary200};
        }
      }
    `}
  }

  .dx-datagrid-rowsview {
    ${({ theme }) => css`
      overflow-x: auto !important;
      border-color: ${theme.ds.colors.primary25};
      border-top: none;

      .dx-row {
        cursor: pointer;
        &:hover {
          background-color: ${theme.ds.colors.neutral100};
        }

        td {
          vertical-align: middle;
          padding: 8px;
          border: none;
          font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
        }
      }
    `}
  }
`

// export const Filters = styled.form`
//   display: flex;
//   align-items: center;
//   gap: 24px;
//   flex-wrap: wrap;
//   width: 100%;
//   margin-bottom: 32px;

//   .inputs {
//     flex: 3;
//     min-width: 250px;
//   }

//   .actions {
//     flex: 1;
//     display: flex;
//     align-items: center;
//     justify-content: flex-end;
//     gap: 16px;
//   }
// `
